import Handlebars from "../handlebars/handlebars";
import RegisterFormController from "./RegisterFormController";
import SignInFormController from "./SignInFormController";
import registerAndSignInHtml from "./registerAndSignIn.hbs"

const FORM_TOGGLE_ELEMENT = '.js-element--formToggle';
const FORM_CONTAINER_ELEMENT = '.js-element--registerAndSignInContainer';

class RegisterAndSignInController {
    constructor (container, onSucessCallback, showRegister) {
        this.state = {
            showRegister: !!showRegister,
        };

        this.container = container;
        this.template = registerAndSignInHtml;
        this.onSucessCallBack = onSucessCallback;

        this.handleClick = this.handleClick.bind(this);
        this.render = this.render.bind(this);

        this.enableUI();
        this.render();
    }

    enableUI () {
        this.container.addEventListener('click', this.handleClick, false);
    }

    render() {
        this.container.innerHTML = this.template(this.state);
        var formContainer = this.container.querySelector(FORM_CONTAINER_ELEMENT);

        this.state.showRegister
            ? new RegisterFormController(formContainer, this.onSucessCallBack)
            : new SignInFormController(formContainer, this.onSucessCallBack);
    }

    handleClick (e) {
        if (e.target.matches(FORM_TOGGLE_ELEMENT)) {
            e.preventDefault();
            this.state.showRegister = !this.state.showRegister;
            this.render();
            return;
        }
    }

}
 export default RegisterAndSignInController;
